import { Component, OnInit } from '@angular/core';
import {CommonService} from '../services/common.service';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {

   path;
   tab = 'saurabh';

   constructor(private common: CommonService) {
   }

   ngOnInit(): void {
      this.path = this.common;
      window.scrollTo(0, 0);
   }
}
